var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 9.19204C10.2735 9.19204 12.1165 7.35819 12.1165 5.09602C12.1165 2.83385 10.2735 1 8.00012 1C5.72673 1 3.88379 2.83385 3.88379 5.09602C3.88379 7.35819 5.72673 9.19204 8.00012 9.19204Z",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7004 9.46387H9.30518C12.451 9.46387 15.0056 12.0058 15.0056 15.1361V16.3572C15.0056 17.6781 13.9291 18.7548 12.596 18.7548H3.40956C2.08207 18.7548 1 17.6837 1 16.3572V15.1361C1 12.0058 3.55458 9.46387 6.7004 9.46387V9.46387Z",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.c52a1162400cedfe304daf321f21ed6b.svg";
export { ForwardRef as ReactComponent };